import React from 'react';

import { bemCssModules } from '@utils';
import { useTapped } from '@utils/hooks';

import style from './Field.scss';

const cn = bemCssModules(style, 'Field');

export type TField = {
  value: React.ReactNode;
  placeholder?: string;
  onClick?(): void;
  tag?: 'button' | 'div' | 'label';
  label?: string;
  right?: React.ReactNode;
  disabled?: boolean;
};

const Field: CustomFC<TField> = props => {
  const { onClick, label, value, placeholder, tag = 'button', right, className, disabled } = props;

  const { handlers, isTapped } = useTapped();
  const Component = tag;

  return (
    <Component
      className={cn({ isTapped }, [className])}
      onClick={onClick}
      type="button"
      disabled={disabled}
      {...handlers}
    >
      <div className={cn('left')}>
        {label && <div className={cn('label')}>{label}</div>}
        <div className={cn('value')}>
          {value || <span className={cn('placeholder')}>{placeholder}</span>}
        </div>
      </div>
      {right && <div className={cn('right')}>{right}</div>}
    </Component>
  );
};

export default Field;
